import { useEffect, useRef, useState } from "react";
import { Heading, TypographyType, TypographyColor, Switch, Body, BodyType, BodyColor } from "../../ui-elements";
import { checkboxState, CIFType, selAggLayerState, hexLoadingState } from "../../states";
import { METRIC_DATA, PARENT_METRIC_TYPES } from "../../constants";
import { useRecoilValue } from "recoil";
interface CifTypeSwitchProps {
    layer: any
    cifType: CIFType[];
    isChecked: boolean;
    handleToggleChange: (event: any) => void;
    disabled: boolean;
    selMetric: {
        EH: any;
        CTV: any;
        PoI: any;
    };
    isPoiOverlapped: boolean;
    customTooltip: string;
    catchment?: any
}

export const CifTypeSwitch: React.FC<CifTypeSwitchProps> = ({ layer, cifType, isChecked, handleToggleChange, disabled, selMetric, isPoiOverlapped, customTooltip, catchment }) => {
    const menuRef = useRef<HTMLDivElement | null>(null);
    const popupRef = useRef<HTMLDivElement | null>(null); // Ref for the popup
    const [popupStyle, setPopupStyle] = useState<{ left: number | string; right: number | string; maxWidth: any; minWidth: string, transform?: string; }>({ left: '', right: '', maxWidth: 192, minWidth: 'fit-content' });
    const [showTooltip, setShowTooltip] = useState(false);
    const [showInfoTooltip, setShowInfoTooltip] = useState(false);
    const selAggLayer = useRecoilValue(selAggLayerState);
    const isCheckedRegion = useRecoilValue(checkboxState); /// Region toggle state(Catchments)
    const hexLoading = useRecoilValue(hexLoadingState);
    const isAdjacencyLoading = layer.type === 'adjacency' && hexLoading.loading && isChecked;
    

    const getSwitchTitle = PARENT_METRIC_TYPES.includes(layer.type) && METRIC_DATA[layer.type as keyof typeof METRIC_DATA]?.key && layer.type !== METRIC_DATA[layer.type as keyof typeof METRIC_DATA]?.key ? METRIC_DATA[layer.type as keyof typeof METRIC_DATA]?.title : layer.title;
    const getTooltipText = customTooltip ? customTooltip : selAggLayer==null ? "Turn on Choropleth to enable this toggle.": layer?.type=="CTV" && isCheckedRegion?.catchments ? "Disabled due to Catchment" : `We do not have ${layer.type} at this level`;

    const onHoverSwitch = () => {
        if (disabled && (layer.type === 'EH' || layer.type === 'CTV' || layer.type === 'MBP' || layer.type === 'catchments'|| layer.type === 'PoI')) setShowTooltip(true);
    }

    useEffect(() => {
        if (showTooltip && (disabled  && (layer.type === 'EH' || layer.type === 'CTV' || layer.type === 'MBP' || layer.type === 'catchments'))) setTimeout(() => setShowTooltip(false), 1500);
    }, [showTooltip, cifType]);

    const handlePopup = () => {
        // Determine the position of the info button
        // const popupWidth = 192;
        const popupWidth = popupRef.current?.getBoundingClientRect().width || 192;
        const infoButtonPosition = menuRef.current?.getBoundingClientRect();

        if (infoButtonPosition) {
            const hasSpaceOnLeft = infoButtonPosition.left >= popupWidth / 2;
            const hasSpaceOnRight = window.innerWidth - infoButtonPosition.right >= popupWidth / 2;

            if (hasSpaceOnLeft && hasSpaceOnRight) {
                // Enough space on both sides, center the popup
                setPopupStyle({ left: '50%', right: 'auto', maxWidth: popupWidth, minWidth: 'fit-content', transform: 'translateX(-50%)' });
            } else if (hasSpaceOnLeft) {
                // Not enough space on the right, position on the left
                // const rightPosition = -(window.innerWidth - infoButtonPosition.right + window.scrollX - 10);
                const rightPosition = -(window.innerWidth - infoButtonPosition.right + window.scrollX + 10);
                setPopupStyle({ left: 'auto', right: rightPosition, maxWidth: popupWidth, minWidth: 'fit-content', transform: 'translateX(0%)' });
            } else if (hasSpaceOnRight) {
                // Not enough space on the left, position on the right
                const lefttPosition = (infoButtonPosition.left + window.scrollX + 50);
                setPopupStyle({ left: lefttPosition, right: 'auto', maxWidth: popupWidth, minWidth: 'fit-content', transform: 'translateX(0%)' });
            }
        }
        setShowInfoTooltip(prev => !prev)
    }
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                popupRef.current &&
                !popupRef.current.contains(event.target as Node) &&
                menuRef.current &&
                !menuRef.current.contains(event.target as Node)
            ) {
                setShowInfoTooltip(false);
            }
        };

        if (showInfoTooltip) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        // Cleanup listener on unmount
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showInfoTooltip]);

    return (
        <div className={`d-flex align-items-start justify-content-between p-0 ${layer.hasOwnProperty('options') ? 'col-12' : 'col-12'}`}>
            <div className=' d-flex justify-content-start align-items-center'>
                {/* {layer.type === 'PoI' && selectedGeo.sub_district && (hasBrands && cifType.includes('PoI')) && <span className="presence-indicator-hover-card poi-indicator"></span>} */}
                {/* <Heading
                    title={`${getSwitchTitle}${layer.type === 'PoI' && selectedGeo.sub_district && selectedTab === 5 && isPoiOverlapped ? `${'*'}` : ''}`}
                    type={layer.type !== 'data-layers' ? TypographyType.h5 : TypographyType.h5}
                    colour={TypographyColor.primary}
                    classname={`text-wrap ${disabled ? 'opacity-50' : ''}`}
                />
                 <InfoPanel text={layer.description} classname={`icon-gray-0 ${disabled ? 'opacity-50' : ''}`} translateX={`${layer.type !== 'data-layers' ? 'translateX(-68%)' : 'translateX(-10%)'}`} />  */}

                <div>
                    <Body
                        type={layer.type === 'data-layers' ? BodyType.p3 : BodyType.p2}
                        color={layer.type === 'data-layers' ? BodyColor.secondary : BodyColor.primary}
                        classname={`text-wrap gap-1 ff-poppins-medium `}
                    >
                        <span className={disabled ? 'opacity-50 ' : ''}>
                            {`${getSwitchTitle}${(layer.type === 'PoI' && isPoiOverlapped) ? '*' : ''}`}

                            {layer.description && <span
                                ref={menuRef}
                                className={`icon-gray-0  material-symbols-outlined fs-16 ms-1`}
                                style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                                onClick={handlePopup}
                            >
                                info
                            </span>}
                        </span>

                        {/* Tooltip appears on clicking the icon */}
                        {showInfoTooltip && (
                            <div className="popupInfo" ref={popupRef} style={{ ...popupStyle, transform: layer.type === 'CTV' ? 'translateX(-31%)' : layer.type === 'PoI' ? 'translateX(-50%)' : 'translateX(-41%)', }}>
                                <p className='margin-0 text-start info-text-wrap' dangerouslySetInnerHTML={{ __html: layer.description?.replace(/\\n/g, '<br>') }}
                                />
                            </div>
                        )}
                    </Body>
                    {/* <span
                        ref={menuRef}
                        className={`icon-gray-0 ${disabled ? 'opacity-50' : ''} material-symbols-outlined fs-16 ms-1`}
                        style={{ cursor: disabled ? 'not-allowed' : 'pointer', }}
                        onClick={handlePopup}
                    >
                        info
                    </span> */}
                </div>
            </div>
            <div
                className="position-relative d-flex justify-content-end align-items-center col-2 p-1"
                onMouseEnter={onHoverSwitch}
                onMouseLeave={() => setShowTooltip(false)}
            >
                {layer.hasOwnProperty('isselected') && (
                    isAdjacencyLoading ? (
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-label="Loading adjacency"
                            style={{ borderWidth: '0.1em', color: '#adb5bd' }}
                        />
                    ) : (
                        <Switch
                            isChecked={isChecked}
                            toggleSwitch={handleToggleChange}
                            name={layer.type}
                            disabled={disabled}
                        />
                    )
                )}
                {showTooltip && disabled &&
                    <div className="position-absolute bg-white switch-tooltip rounded">
                        <Heading
                            title={getTooltipText}
                            type={TypographyType.h6}
                            colour={TypographyColor.secondary}
                            classname='text-start padding-2'
                        />
                    </div>
                }
            </div>
        </div>
    )
};